<template>
    <div>

        <div class="grid grid-cols-1 md:grid-cols-2">
            <div>
                <label for="account_type_card_number">Número de tarjeta:</label>
                <input type="radio" value="Numero de tarjeta" v-model="savingModelValidations.account_type"  name="rdbStatus"  id="account_type_card_number" style="margin-left: 15px;" v-on:change="changeAccountType($event.target.value)">
            </div>

            <div>
                <label for="account_type_key_account">Cuenta clabe:</label>
                <input type="radio" value="Cuenta Clabe" v-model="savingModelValidations.account_type"  name="rdbStatus"  id="account_type_key_account" style="margin-left: 15px;" v-on:change="changeAccountType($event.target.value)">
            </div>

            <div v-for="(error,index) of savingDataModelValidations.account_type.$errors" :key="index" :id="'div_error_account_type_'+index" :class="view_class_view.div_container_error.container+' '+view_class_view.div_container_error.text_error">
                {{ error.$message }}
            </div>
        </div>

        <div class="mt-5">

            <div>
                <label>Banco:</label>
                <select translate="no"
                v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: savingDataModelValidations.bank_name.$error,
                    [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!savingDataModelValidations.bank_name.$invalid,
                    [view_class_view.classInputs.default ]: savingDataModelValidations.bank_name.$invalid && !savingDataModelValidations.bank_name.$error}"
                v-model="savingModelValidations.bank_name" id="select_bank_name"
                @blur="savingDataModelValidations.bank_name.$validate">
                    <option value="" selected disabled id="option_bank_default">Seleccionar una opción</option>
                    <option :value="item.name" v-for="(item,index) in list_banks" :key="item.id" :id="'option_bank_'+index" >{{item.name}}</option>
                </select>

                <div v-for="(error,index) of savingDataModelValidations.bank_name.$errors" :key="index" :id="'div_error_bank_name_'+index" :class="view_class_view.div_container_error.container+' '+view_class_view.div_container_error.text_error">
                  {{ error.$message }}
                </div>
            </div>

            <div class="mt-5">
                <div v-show="savingModelValidations.account_type=='Cuenta Clabe'">
                    <label for="id_interbank_code">Clabe interbancaria:</label>
                    <input type="text" id="input_card_number_saving_data"
                    v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: savingDataModelValidations.account_number.$error,
                        [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!savingDataModelValidations.account_number.$invalid,
                        [view_class_view.classInputs.default ]: savingDataModelValidations.account_number.$invalid && !savingDataModelValidations.account_number.$error}"
                    v-model="savingModelValidations.account_number"
                    inputmode="numeric" v-maska="'##################'">
                </div>

                <div v-show="savingModelValidations.account_type=='Numero de tarjeta'">
                    <label for="id_interbank_code">Número de tarjeta:</label>
                    <input type="text" id="input_card_number_saving_data" v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: savingDataModelValidations.account_number.$error,
                        [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!savingDataModelValidations.account_number.$invalid,
                        [view_class_view.classInputs.default ]: savingDataModelValidations.account_number.$invalid && !savingDataModelValidations.account_number.$error}"
                    v-model="savingModelValidations.account_number"
                    v-maska="savingModelValidations.bank_name=='AMERICAN EXPRESS'?'####-######-#####':'####-####-####-####'" inputmode="numeric">
                </div>

                <div v-for="(error,index) of savingDataModelValidations.account_number.$errors" :key="index" :id="'div_error_account_number_'+index" :class="view_class_view.div_container_error.container+' '+view_class_view.div_container_error.text_error">
                  {{ error.$message }}
                </div>
            </div>

            <div class="mt-5" v-show="savingModelValidations.account_type=='Numero de tarjeta'">
                <label>Fecha Vencimiento:</label>
                <div class="flex w-full ">
                    <div class="w-full">
                        <select style="border-right:none;border-top-right-radius:0;border-bottom-right-radius:0"
                        v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: savingDataModelValidations.expiration_month.$error,
                        [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!savingDataModelValidations.expiration_month.$invalid,
                        [view_class_view.classInputs.default ]: savingDataModelValidations.expiration_month.$invalid && !savingDataModelValidations.expiration_month.$error}"
                        id="input_expiration_date_saving_data_month" v-on:change="changeExpirationMonth($event.target.value)"
                        v-model="savingModelValidations.expiration_month" >
                            <option value="" selected="true" disabled="disabled">MM</option>
                            <option :value="month" v-for="(month, i) in list_months" :key="i" :id="'option_month_'+i">{{month}}</option>
                        </select>
                    </div>

                    <div class="w-full">
                        <select style="border-left:none;border-top-left-radius:0;border-bottom-left-radius:0"
                        v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: savingDataModelValidations.expiration_year.$error,
                        [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!savingDataModelValidations.expiration_year.$invalid,
                        [view_class_view.classInputs.default ]: savingDataModelValidations.expiration_year.$invalid && !savingDataModelValidations.expiration_year.$error}"
                        id="input_expiration_date_saving_data_year" v-on:change="changeExpirationYear($event.target.value); getMonths($event.target.value);"
                        v-model="savingModelValidations.expiration_year">
                            <option value="" selected="true" disabled="disabled">AA</option>
                            <option :value="year" v-for="(year, i) in list_years" :key="i" :id="'option_year_'+i">{{year}}</option>
                        </select>
                    </div>
                </div>

                <div v-for="(error,index) of savingDataModelValidations.expiration_month.$errors" :key="index" :id="'div_error_expiration_month_'+index" :class="view_class_view.div_container_error.container+' '+view_class_view.div_container_error.text_error">
                  {{ error.$message }}
                </div>

                <div v-for="(error,index) of savingDataModelValidations.expiration_year.$errors" :key="index" :id="'div_error_expiration_year_'+index" :class="view_class_view.div_container_error.container+' '+view_class_view.div_container_error.text_error">
                  {{ error.$message }}
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import { onMounted,ref, watch } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default
{
    name:"GifCardComponent",
    props:{
        list_banks:{
            type: Array,
        },
        validations:{
            type: Object
        },
        view_class_view:{
            type: Object,
            required:true
        },
    },
    setup(props)
    {
        const list_months = ref([]);
        const list_years = ref([]);

        const savingModelValidations = ref({
            bank_name: "",
            account_type: "",
            account_number: "",
            expiration_year: "",
            expiration_month: ""
        });

        let savingDataModelValidations = useVuelidate(props.validations, savingModelValidations);

        onMounted( async () => {
            getYearsCard();
            getMonths(parseInt((new Date().getMonth()+1).toString().substring(2, 4)));

        });

        function getYearsCard(){
            var years = [];
            var startYear = new Date().getFullYear() - 1;
            var lastYear = new Date().getFullYear() + 5;
            
            while (parseInt(startYear) < parseInt(lastYear) ) {
                startYear++;
                var year = startYear;
                years.push(parseInt(year.toString().substring(2, 4)));
            }
            list_years.value = years;
            return years;
        }

        function getMonths(date){
            list_months.value = [];
            date = parseInt(date);
            let month = new Date().getMonth()+1;
            let months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
            if(date === list_years.value[0])
            {
                months.forEach(element => {
                    if(element >= month){
                    list_months.value.push(element);
                    }
                });
            }
            else{
                list_months.value = months;
            }
        }

        function changeExpirationYear(value){
            savingModelValidations.value.expiration_year = value;
        }

        function changeExpirationMonth(value){
            savingModelValidations.value.expiration_month = value;
        }

        function changeAccountType(value, clear = true){
            savingModelValidations.value.account_type = value;
            if(clear){
                clearControls();
            }
        }

        function execute_validation(){
            savingDataModelValidations.value.$validate();
            if(savingDataModelValidations.value.$error){
                return false;
            }
            return savingModelValidations.value;
        }

        function clearControls(){
            savingModelValidations.value.account_number = "";
            savingModelValidations.value.expiration_month = "";
            savingModelValidations.value.expiration_year = "";
            savingModelValidations.value.bank_name = "";
        }

        watch(() => savingModelValidations.value.account_type, (value) => {
           document.getElementById("account_type_card_number").checked = value == "Numero de tarjeta"
           document.getElementById("account_type_key_account").checked = value == "Cuenta Clabe"
        });

        return{
            getYearsCard,
            getMonths,
            list_months,
            list_years,
            changeExpirationYear,
            changeExpirationMonth,
            savingModelValidations,
            savingDataModelValidations,
            changeAccountType,
            execute_validation
        }
    }
}
</script>